interface TerravisionMarkProps {
  size?: number;
}

export function TerravisionMark({ size = 34 }: TerravisionMarkProps) {
  const radius = Math.round(size * 0.24);
  const inner = Math.round(size * 0.59);

  return (
    <div
      aria-hidden="true"
      style={{
        width: size,
        height: size,
        borderRadius: radius,
        background: 'linear-gradient(135deg, #2c3a78 0%, #11162f 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}
    >
      <svg
        width={inner}
        height={inner}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Contour lines — topographic glyph */}
        <line x1="2" y1="5.5"  x2="18" y2="5.5"  stroke="#aeb6d4" strokeWidth="1.5" strokeLinecap="round" />
        <line x1="2" y1="10"   x2="14" y2="10"   stroke="#aeb6d4" strokeWidth="1.5" strokeLinecap="round" />
        <line x1="2" y1="14.5" x2="16" y2="14.5" stroke="#aeb6d4" strokeWidth="1.5" strokeLinecap="round" />
        {/* Accent dot — blue data point */}
        <circle cx="17" cy="14.5" r="1.8" fill="#3b82f6" />
      </svg>
    </div>
  );
}
